(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beach-store-hours"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beach-store-hours')) {
    class BeachStoreHours extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.stores = Array.from(this.querySelectorAll('[data-store]')).map(
          (element) => {
            const rows = Array.from(element.querySelectorAll('[data-day]'));
            const schedule = rows.map((row) => {
              const entry = this.parseHours(row.dataset.hours);
              row.querySelector('[data-hours-label]').textContent =
                this.formatEntry(entry);
              return entry;
            });

            return { element, rows, schedule };
          }
        );

        try {
          this.clock = new Intl.DateTimeFormat('en-US', {
            timeZone: this.dataset.timezone || 'America/New_York',
            weekday: 'short',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23'
          });
        } catch (error) {
          this.clock = null;
        }

        this.refresh();
        this.timer = window.setInterval(() => this.refresh(), 30000);

        document.addEventListener(
          'visibilitychange',
          () => {
            if (!document.hidden) this.refresh();
          },
          { signal }
        );

        this.addEventListener(
          'shopify:block:select',
          () => {
            this.querySelector('details').open = true;
          },
          { signal }
        );
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.controller?.abort();
        this.controller = null;
      }

      parseHours(value) {
        const raw = (value || '').trim();

        if (/^closed$/i.test(raw)) {
          return { type: 'closed' };
        }

        if (/^24h$/i.test(raw)) {
          return { type: 'all-day' };
        }

        const match = raw.match(
          /^([01]?\d|2[0-3]):([0-5]\d)\s*[-–]\s*([01]?\d|2[0-3]):([0-5]\d)$/
        );

        if (!match) return { type: 'unknown' };

        const start = Number(match[1]) * 60 + Number(match[2]);
        const end = Number(match[3]) * 60 + Number(match[4]);

        if (start === end) return { type: 'unknown' };

        return { type: 'hours', start, end };
      }

      formatTime(minutes, compact = false) {
        const hour = Math.floor(minutes / 60) % 24;
        const minute = minutes % 60;
        const suffix = hour >= 12 ? 'PM' : 'AM';
        const minuteText =
          compact && minute === 0
            ? ''
            : ':' + String(minute).padStart(2, '0');

        return `${hour % 12 || 12}${minuteText} ${suffix}`;
      }

      formatEntry(entry) {
        if (entry.type === 'closed') return 'Closed';
        if (entry.type === 'all-day') return 'Open 24 hours';
        if (entry.type === 'unknown') return 'Hours unavailable';

        const nextDay = entry.end < entry.start ? ' (+1 day)' : '';

        return (
          this.formatTime(entry.start) +
          ' – ' +
          this.formatTime(entry.end) +
          nextDay
        );
      }

      getStatus(store, day, minute) {
        const mode = store.element.dataset.statusMode;

        if (mode === 'closed') {
          return { state: 'closed', text: 'Closed' };
        }

        if (mode === 'open') {
          return { state: 'open', text: 'Open' };
        }

        if (day === null) {
          return { state: 'unknown', text: 'See hours' };
        }

        const today = store.schedule[day];
        const yesterday = store.schedule[(day + 6) % 7];

        if (today.type === 'all-day') {
          return { state: 'open', text: 'Open 24 hours' };
        }

        if (
          yesterday.type === 'hours' &&
          yesterday.end < yesterday.start &&
          minute < yesterday.end
        ) {
          return {
            state: 'open',
            text: 'Open · til ' + this.formatTime(yesterday.end, true)
          };
        }

        if (today.type === 'hours') {
          const isOpen =
            today.end > today.start
              ? minute >= today.start && minute < today.end
              : minute >= today.start;

          if (isOpen) {
            return {
              state: 'open',
              text: 'Open · til ' + this.formatTime(today.end, true)
            };
          }
        }

        if (today.type === 'unknown' || yesterday.type === 'unknown') {
          return { state: 'unknown', text: 'See hours' };
        }

        return { state: 'closed', text: 'Closed' };
      }

      refresh() {
        let day = null;
        let minute = null;

        if (this.clock) {
          const parts = Object.fromEntries(
            this.clock.formatToParts(new Date()).map(
              (part) => [part.type, part.value]
            )
          );

          day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(
            parts.weekday
          );
          minute = Number(parts.hour) * 60 + Number(parts.minute);

          if (day < 0) day = null;
        }

        let openCount = 0;
        let unknownCount = 0;

        this.stores.forEach((store) => {
          store.rows.forEach((row, index) => {
            const isToday = index === day;
            row.classList.toggle('is-today', isToday);

            const heading = row.querySelector('th');
            if (isToday) {
              heading.setAttribute('aria-label', heading.textContent + ', today');
            } else {
              heading.removeAttribute('aria-label');
            }
          });

          const status = this.getStatus(store, day, minute);
          const badge = store.element.querySelector('[data-store-status]');
          const label = badge.querySelector('[data-store-status-text]');

          badge.hidden = false;
          badge.dataset.state = status.state;
          if (label.textContent !== status.text) label.textContent = status.text;

          if (status.state === 'open') openCount += 1;
          if (status.state === 'unknown') unknownCount += 1;
        });

        const summary = this.querySelector('[data-summary-status]');
        const summaryText = this.querySelector('[data-summary-text]');
        const total = this.stores.length;

        summary.hidden = total === 0;
        if (!total) return;

        let message;

        if (unknownCount > 0) {
          message = openCount
            ? `${openCount} ${openCount === 1 ? 'store' : 'stores'} open · see hours`
            : 'See store hours';
        } else if (openCount === 0) {
          message = total === 1 ? 'Store closed' : 'All stores closed';
        } else if (openCount === total) {
          message = total === 1 ? 'Store open' : `All ${total} stores open`;
        } else {
          message = `${openCount} of ${total} stores open`;
        }

        summary.dataset.state = openCount
          ? 'open'
          : unknownCount
            ? 'unknown'
            : 'closed';

        if (summaryText.textContent !== message) {
          summaryText.textContent = message;
        }
      }
    }

    customElements.define('beach-store-hours', BeachStoreHours);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizon-category-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('category-faq-horizon')) {
    customElements.define('category-faq-horizon', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.tabs = Array.from(this.querySelectorAll('.cfq-tab'));
        this.panels = Array.from(this.querySelectorAll('.cfq-panel'));
        if (!this.tabs.length) return;
        this.setAttribute('data-enhanced', '');
        this.querySelector('.cfq-nav').setAttribute('role', 'tablist');
        this.tabs.forEach(tab => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
          tab.addEventListener('click', event => { event.preventDefault(); this.selectCategory(tab.dataset.category); }, options);
          tab.addEventListener('keydown', event => {
            const index = this.tabs.indexOf(tab);
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;
            if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (event.key === ' ') { event.preventDefault(); this.selectCategory(tab.dataset.category); }
            if (next !== undefined) { event.preventDefault(); this.selectCategory(this.tabs[next].dataset.category); this.tabs[next].focus({preventScroll: true}); this.tabs[next].scrollIntoView({block:'nearest',inline:'nearest'}); }
          }, options);
        });
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.category === panel.dataset.category).id);
          panel.tabIndex = 0;
          const items = Array.from(panel.querySelectorAll('details'));
          items.forEach(item => item.addEventListener('toggle', () => {
            if (item.open && this.dataset.single === 'true') items.forEach(other => { if (other !== item) other.open = false; });
          }, options));
          if (this.dataset.openFirst === 'true' && items[0]) items[0].open = true;
        });
        this.selectCategory(this.tabs[0].dataset.category);
        document.addEventListener('shopify:block:select', event => {
          const item = Array.from(this.querySelectorAll('[data-faq-block]')).find(el => el.dataset.faqBlock === event.detail?.blockId);
          if (!item) return;
          this.selectCategory(item.closest('.cfq-panel').dataset.category);
          item.open = true;
        }, options);
      }
      selectCategory(category) {
        this.tabs.forEach(tab => {
          const selected = tab.dataset.category === category;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.category !== category; });
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
